import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://lecugcvaoiurbfwastkh.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxlY3VnY3Zhb2l1cmJmd2FzdGtoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY4NjAxNzQsImV4cCI6MjA3MjQzNjE3NH0.cPqMCQ86kNiKIWacPAP7NEiU0ZGBk0y9vqF1xQWcssY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
